import { render, staticRenderFns } from "./PermissionPopup.vue?vue&type=template&id=19540795&"
import script from "./PermissionPopup.vue?vue&type=script&lang=js&"
export * from "./PermissionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports